// extracted by mini-css-extract-plugin
export var cardContainer = "_qg-0";
export var cardHeader = "_qg-2";
export var collapsedState = "_qg-3";
export var dragHandle = "_qg-5";
export var dragHandleIcon = "_qg-6";
export var dragging = "_qg-1";
export var titleArea = "_qg-4";